import { WorkgroupsApi } from './workgroup.api'
export { WorkgroupsApi } from './workgroup.api'

export default {
  workgroups: WorkgroupsApi
}
